/**
 * GraphQL Query
 * 決済ログ画面
 */

/**
 * 決済ログ_クレジット(リクエスト)
 */
export const GRAPH_QL_QUERY_PAYMENT_CREDIT =
`
  paymentLists ( ?, paymentMethodRefid:[1,9] ) {
`
/**
 * 決済ログ_コンビニ(リクエスト)
 */
export const GRAPH_QL_QUERY_PAYMENT_CVS =
`
  paymentLists ( ?, paymentMethodRefid:[3] ) {
`
/**
 * 決済ログ_キャリア(リクエスト)
 */
export const GRAPH_QL_QUERY_PAYMENT_CARRIER =
`
  paymentLists ( ?, paymentMethodRefid:[2,8] ) {
`
/**
 * 決済ログ_ID(リクエスト)
 */
export const GRAPH_QL_QUERY_PAYMENT_ID =
`
  paymentLists ( ?, paymentMethodRefid:[4]) {
`

/**
 * 決済ログ(レスポンス)
 */
export const GRAPH_QL_QUERY_PAYMENT_LIST =
`
  edges {
    node {
      site_code
      uuid
      customerNo
      orderNo
      orderDatetime
      paid_at
      createdAt
      amount
      payment_method_refid
      transaction_id_1
      transaction_id_3
      lastCreditCompletionDate
      carrierCompletionDate
      payLimit
      processed_at
      canseled_at
      transactionId
      settlementNo
      kessaiNumber
      error_reason_code
      process_code
      status_code
      kaiinId
      response_code
      payType
      processEndDate
      qty {
        current
        ordered
        unallocated
        pending
        preExport
        preReExport
        canceled
        exported
        shipped
        unshipped
        inshipCanceled
        transfer
        receiveShipped
        receiveFixed
        exOut
        exOutExported
        exOutShipped
        exOutUnshipped
        exOutFixed
        exIn
        exInShipped
        exInFixed
      }
      isShipment
    }
  }
  totalCount
`
